<template>
  <!-- 登录弹窗 -->
  <div class="tip" :class="{'hasBtn': showBtns}">
    <div class="tip-content" :class="ico">
      <div class="tip-text">{{text}}</div>
      <div class="btns" v-if="showBtns">
        <button class="button cancel" @click="cancelBtn">{{cancelBtnText}}</button>
        <button class="button confirm" @click="confirmBtn">{{confirmBtnText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: 'tipModal',
  props: {
    text: String,
    showBtns: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Number,
      default: 2000
    },
    ico: {
      type: String,
      default: 'fail'
    },
    fun: Function,
    confirmFun: Function,
    cancelFun: Function,
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    }
  },
  mounted(){
    if(!this.showBtns){
      let _this = this;
      setTimeout(() => {
        _this.CloseTipModal();
        if(_this.fun){
          _this.fun();
        }
      }, _this.showTime);
    }
  },
  methods: {
    ...mapMutations(['CloseTipModal']), //tip弹窗
    //取消按钮
    cancelBtn(){
      this.cancelFun ? this.cancelFun() : this.CloseTipModal();
    },
    confirmBtn(){
      this.confirmFun();
    }
  }
}
</script>

<style scoped lang="scss">
.tip{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  .tip-content{
    max-width: 90%;
    padding: 10px 30px 10px 60px;
    border-radius: 5px;
    &.fail{
      background: url(~@/assets/m/exclamation-white.png) no-repeat 30px center rgba(0, 0, 0, 0.4);
      background-size: 20px;
    }
    &.success{
      background: url(~@/assets/m/tick2.png) no-repeat 30px center rgba(0, 0, 0, 0.4);
      background-size: 20px;
    }
  }
  .tip-text{
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 24px;
  }
  &.hasBtn{
    background: rgba(0, 0, 0, 0.4);
    .tip-content{
      width: 320px;
      padding: 0;
      background: #fff;
      .tip-text{
        padding: 32px 24px;
        font-weight: 600;
        font-size: 16px;
        color: #000;
      }
    }
    .btns{
      display: flex;
      justify-content: center;
      border-top: 1px solid #E7E7E7;
      .button{
        padding: 0;
        width: 50%;
        height: 56px;
        background-color: #fff;
        font-size: 16px;
        &.confirm{
          color: #E15416;
          border-left: 1px solid #E7E7E7;
        }
      }
    }
  }
}
</style>
